/**
 * Adds a response action to the very last action in the sequence,
 * so we can detect when the entire sequence has completed.
 * @param {Object} action - An API action generated via apiAction().
 * @param {String} completeActionType - Action type to be added.
 * @returns {Object} A new action containing the passed in action with the new completed action added.
 */
export const addCompleteAction = (action = {}, completeActionType) => {
    if (!completeActionType || typeof completeActionType !== 'string') {
        /**
         * Redux only requires it to be !undefined, but it's recommended to be a string.
         * https://github.com/reactjs/redux/blob/0babfab2e1ac4af38364a79204ade4480990db99/src/createStore.js#L157
         */
        throw new Error('Action type must be a string');
    }

    // Root of action, step into the apiSchema
    if (action.apiSchema) {
        // only called at root of action
        return {
            ...action,
            apiSchema: addCompleteAction(action.apiSchema, completeActionType)
        };
    }

    // If there is an onNext, step into it
    if (action.onNext) {
        return {
            ...action,
            onNext: addCompleteAction(action.onNext, completeActionType)
        };
    }

    // Append the complete action, so we know when all the actions are complete
    return {
        ...action,
        responseActions: (action.responseActions || []).concat({ type: completeActionType })
    };
};
